'use client';

import React from 'react';
import Footer from '@/components/layout/Footer';
import HeaderSection from '@/components/layout/HeaderSection';
import CoreValuesSection from './components/CoreValuesSection';
import DetailedValuesSection from './components/DetailedValuesSection';
import { useAboutPageData } from './hooks/useAboutPageData';

/**
 * AboutPage Component
 * Main component for the About page that composes all sections
 */
export default function AboutPage() {
  const data = useAboutPageData();

  return (
    <div className="  ">
      {/* Header Section */}
      <HeaderSection
        title={data.headerTitle}
        subtitle={data.headerSubtitle}
        backgroundImage={data.headerBackgroundImage}
      />

      {/* Main content area */}
      <div className="bg-white">
        {/* Core Values Section */}
        <CoreValuesSection coreValues={data.coreValues} />

        {/* Detailed Core Values Section */}
        <DetailedValuesSection
          title={data.detailedValuesTitle}
          subtitle={data.detailedValuesSubtitle}
          imageSrc={data.detailedValuesImage}
          imageAlt={data.detailedValuesImageAlt}
          values={data.detailedValues}
        />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
